<template>
  <nav v-if="items.length === 0" class="ren-decoration-cp ren-decoration-cp-horizontal-menu is-empty">
    暂无菜单项
  </nav>
  <nav v-else class="ren-decoration-cp ren-decoration-cp-horizontal-menu" :style="rowStyle">
    <span
      v-for="(item, index) in items"
      :key="itemKey(item, index)"
      :class="{ 'is-active': index === activeIndex }"
      :style="itemStyle(index)">
      {{ itemTitle(item) }}
    </span>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import {
  numberValue,
  previewBoundString,
  previewRecordsFor,
  recordList,
  stringValue
} from '../../../previews/preview-helpers'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()

const items = computed(() =>
  previewRecordsFor(props.component, props.componentData, recordList(props.component.props?.items)).slice(0, 12)
)
const activeIndex = computed(() => {
  const value = Math.round(numberValue(props.component.props?.activeIndex, 0))
  if (items.value.length === 0) return 0
  return Math.max(0, Math.min(items.value.length - 1, value))
})
const rowStyle = computed(() => {
  const gap = Number(props.component.style?.gap)
  const color = stringValue(props.component.style?.textColor)
  return {
    gap: Number.isFinite(gap) && gap >= 0 ? `${gap}px` : undefined,
    color: color || undefined
  }
})

function itemTitle(item: Record<string, unknown>) {
  return previewBoundString(
    props.component,
    props.componentData,
    'item.title',
    stringValue(item.title ?? item.label ?? item.name, '菜单'),
    item
  )
}

function itemKey(item: Record<string, unknown>, index: number) {
  return stringValue(item.id ?? item.code, `${itemTitle(item)}-${index}`)
}

function itemStyle(index: number) {
  if (index !== activeIndex.value) return undefined
  const color =
    stringValue(props.component.style?.activeColor) ||
    props.themeTokens?.primaryColor ||
    props.themeColor ||
    'var(--ren-theme-primary)'
  return { color, borderBottomColor: color }
}
</script>

<style scoped>
.ren-decoration-cp-horizontal-menu {
  display: flex;
  align-items: center;
  overflow-x: auto;
  min-height: 42px;
  background: transparent;
  color: var(--ren-theme-text);
}

.ren-decoration-cp-horizontal-menu.is-empty {
  justify-content: center;
  color: var(--ren-theme-muted);
  font-size: 12px;
}

.ren-decoration-cp-horizontal-menu span {
  flex: 0 0 auto;
  padding: 8px;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
}

.ren-decoration-cp-horizontal-menu .is-active {
  font-weight: 500;
}
</style>
